import { Banner, BannerStatus, Button, Text, VSpacer } from '@/components/DesignSystem';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { Divider, Stack } from '@mui/material';

export const BannerDemo = () => {
  const statuses: BannerStatus[] = ['error', 'info', 'success', 'warning'];

  return (
    <>
      <Text>With Icon</Text>
      <VSpacer size="5" />
      <Stack
        alignItems="center"
        direction="row"
        divider={<Divider flexItem orientation="vertical" />}
        spacing={2}
      >
        {statuses.map((status) => (
          <Banner
            actionButtons={[
              <Button
                key={`${status}-with-icon-action-button`}
                square
                testID="banner-action-button"
                variant="outlined"
              >
                Action
              </Button>,
            ]}
            icon={<CalendarTodayIcon />}
            key={status}
            messages={["Lorem ipsum dolor sit amet"]}
            status={status}
            title="Title"
          />
        ))}
      </Stack>
      <VSpacer size="5" />
      <Text>Without Icon</Text>
      <VSpacer size="5" />
      <Stack spacing={2}>
        {statuses.map((status) => (
          <Banner
            actionButtons={[
              <Button
                key={`${status}-without-icon-action-button`}
                square
                testID="banner-action-button"
                variant="outlined"
              >
                Action
              </Button>,
            ]}
            key={status}
            messages={["Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet"]}
            onClose={() => console.log('close')}
            status={status}
            title="Lorem ipsum dolor sit amet"
          />
        ))}
      </Stack>
      <VSpacer size="4" />
      <Stack spacing={2}>
        {statuses.map((status) => (
          <Banner
            key={status}
            messages={["Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet"]}
            onClose={() => console.log('close')}
            status={status}
            title="Lorem ipsum dolor sit amet"
          />
        ))}
      </Stack>
    </>
  );
};
